// src/apiService.js
import axios from 'axios'; // Make sure this line is present

const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}`; // Replace with your actual API base URL

const getAuthKey = () => {
    return `${process.env.REACT_APP_API_SECURITY_KEY}`;
  };

// Fetch all countries from the API
export const fetchCardsData = async (clientId) => {
    try {
      
      const response = await axios.get(`${API_BASE_URL}/client/dash/dashvalues/${clientId}`,
        {
          headers: {
            'auth_key': `${getAuthKey()}`,
          }
        }
      );
      console.log(response);
      if (!response.status==200) {
        alert('Network response was not ok');
        throw new Error('Network response was not ok');
      }
  
      const data = await response.data;
     // Check for specific status codes in the response
      //const data = {'statusCode': 1002,'result': 'success'};
      if (data.statusCode === 1002) {
        // Returning a specific error message if the user already exists
        return { error: data.result };
      }else if(data.statusCode===1001){
        return { success: data.result };
      }else{
        return { error: 'Fail' };
      }
      return data; // Return the API response
    } catch (error) {
      console.error('Error fetching countries:', error);
      alert('Error fetching countries:'+ error);
      throw error;
    }
  };

  export const fetchChartData = async (month) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/client/dash/getcahartdatabyorganization/${month}/${localStorage.getItem('clientID')}`,
      {
          headers: {
            'auth_key': `${getAuthKey()}`,
          }
        }
      );
      const resultData = response.data.result;
      return resultData;
    } catch (error) {
      console.error('Error fetching countries:', error);
      alert('Error fetching countries:'+ error);
      throw error;
    } 
  };
  
    